import React from "react";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { fontWeightClass } from "~/assets/styles/classes/InputClasses";
import "../../../assets/styles/Slider.css";

type SliderFieldProps = {
  id: string;
  label?: string;
  required?: boolean;
  fontWeight?: "bold" | "normal" | "extrabold";
  errorLabel?: string;
  disabled?: boolean;
  hideLabel?: boolean;
  borderClass?:
    | "rounded-none"
    | "rounded-sm"
    | "rounded"
    | "rounded-md"
    | "rounded-lg"
    | "rounded-xl"
    | "rounded-2xl"
    | "rounded-3xl";
  readOnly?: boolean;
  onClick?: () => void;
  autoFocus?: boolean;
  min?: number;
  max?: number;
  step?: number;
  value?: number;
  valueLabel: string;
  onChange: (value: number) => void;
  testId?:string
};

export const SliderField: React.FC<SliderFieldProps> = ({
  id,
  label = "Slider",
  required = false,
  fontWeight = "bold",
  errorLabel,
  disabled = false,
  hideLabel = false,
  borderClass = "rounded-lg",
  readOnly = false,
  onClick,
  autoFocus = false,
  min = 0,
  max = 8,
  step = 1,
  value,
  valueLabel,
  onChange,
  testId
}) => {
  return (
    <div className="relative w-full">
      {!hideLabel && (
        <label
          htmlFor={id}
          className={`inline-block cursor-pointer text-sm ${fontWeightClass(
            fontWeight
          )} ${errorLabel ? "text-error" : ""}`}
        >
         {label}   {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative flex flex-col gap-2 mt-1">
        <input
          type="range"
          id={id}
          data-test-id={testId}
          min={min}
          max={max}
          step={step}
          value={value ?? ""}
          onChange={(e) => onChange(Number(e.target.value))}
          onClick={onClick}
          autoFocus={autoFocus}
          readOnly={readOnly}
          disabled={disabled}
          className="
            slider-pink
            w-full
            focus:outline-none
            focus-visible:ring-2
            focus-visible:ring-[#D073BE]
            focus-visible:ring-offset-2
          "
          style={
            {
              "--value": value ?? min,
              "--min": min,
              "--max": max,
            } as React.CSSProperties
          }
        />

        <div className="text-sm">
          {valueLabel}: <strong>{value ?? "-"}</strong>
        </div>
      </div>

      {errorLabel && (
        <div className="flex items-center gap-1 mt-1 text-error">
          <HighlightOffRoundedIcon fontSize="small" />
          <span className="text-sm leading-[18px]">{errorLabel}</span>
        </div>
      )}
    </div>
  );
};
